import type { CSSProperties } from "react";

// Design tokens lifted verbatim from the Claude Design (geo.zynday.com.dc.html).
export const C = {
  bg: "#0a0b0a",
  panel: "#0c0f0c",
  panelAlt: "#0e120e",
  inset: "#08090a",
  text: "#cfe8d8",
  textBright: "#e6fff0",
  textBrightest: "#eafff2",
  muted: "#7d978a",
  mutedDim: "#5e7568",
  mutedSoft: "#85a092",
  soft: "#adc4b6",
  ac: "var(--ac)",
  acRaw: "#36e07f",
  acInk: "#062414",
  line: "#15201a",
  line2: "#1b2a20",
  line3: "#234231",
  danger: "#e07a7a",
  dangerLine: "#3a1f1f",
  dangerLine2: "#5a2a2a",
  warn: "#e0c07a",
} as const;

export const FONT =
  "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

export const acGlow = (alpha = 0.3) => `0 0 22px rgba(54,224,127,${alpha})`;

// Shared building-block styles.
export const card: CSSProperties = {
  background: C.panel,
  border: `1px solid ${C.line2}`,
  borderRadius: 10,
  padding: 22,
};

export const btnPrimary: CSSProperties = {
  background: C.ac,
  border: "none",
  color: C.acInk,
  padding: "13px 26px",
  borderRadius: 6,
  font: `700 14px ${FONT}`,
  cursor: "pointer",
  boxShadow: acGlow(0.3),
};

export const btnGhost: CSSProperties = {
  background: "transparent",
  border: `1px solid ${C.line3}`,
  color: C.text,
  padding: "11px 18px",
  borderRadius: 6,
  font: `600 13px ${FONT}`,
  cursor: "pointer",
};

export const input: CSSProperties = {
  width: "100%",
  background: C.bg,
  border: `1px solid ${C.line3}`,
  borderRadius: 7,
  padding: 12,
  color: C.textBrightest,
  font: `500 13px ${FONT}`,
};

export const sectionLabel: CSSProperties = {
  color: C.ac,
  fontWeight: 700,
  letterSpacing: ".14em",
  marginBottom: 18,
  fontSize: 13,
};

export const page: CSSProperties = {
  minHeight: "100vh",
  background: C.bg,
  color: C.text,
  fontFamily: FONT,
  WebkitFontSmoothing: "antialiased",
};

export const logoDot: CSSProperties = {
  width: 9,
  height: 9,
  background: C.ac,
  borderRadius: 2,
  boxShadow: `0 0 11px ${C.ac}`,
  display: "inline-block",
};
